// NPM imports
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

// Component
import EmptyState from '../../../../components/EmptyState';
import GroupedTable from './components/GroupedTable';
import StockTotalizer from './components/StockTotalizer';
import LoadingIndicator from '../../../../components/LoadingIndicator';
import AlertMessage from '../../../../components/AlertMessage';

// Selectors
import { getStockCurrentUI, getStockCurrentTotalizerUI, getStockCurrentList } from '../../../../redux/selectors';

// Actions
import { getCurrentStock, getTotalStock } from '../../../../redux/stock';
import './styles.css';

const propTypes = {
  stockCurrentList: PropTypes.arrayOf(PropTypes.object),
  stockCurrentTotalizer: PropTypes.object,
};

const defaultProps = {
  stockCurrentList: [],
  stockCurrentTotalizer: {},
};

class StockCurrent extends Component {
  componentDidMount = () => {
    this._getCurrentStock();
  }

  _getCurrentStock = (query = '') => {
    this.props.dispatch(getCurrentStock(query));
    this.props.dispatch(getTotalStock(query));
  }

  _onRetry = () => {
    this.props.dispatch(getCurrentStock());
    this.props.dispatch(getTotalStock());
  }

  render() {
    const {
      grouped,
      stockCurrentList,
      stockCurrentTotalizer,
      ui,
      uiTotalizer,
    } = this.props;

    return (
      <div className="StockCurrent">
        {/* ================================ */}
        {/* ERROR STATE - TOTALIZER          */}
        {/* ================================ */}
        {
          uiTotalizer.error &&
          <AlertMessage
            error
            box
            className="StockCurrent__error-message"
            message="Ocorreu um erro ao carregar os totalizadores."
            actionText="Tente novamente"
            onRetry={this._onRetry}
          />
        }

        {/* ================================ */}
        {/* LOADING STATE - TOTALIZER        */}
        {/* ================================ */}
        {
          uiTotalizer.isFetching &&
          <LoadingIndicator
            text="Carregando totalizadores"
            theme="dark"
            className="StockCurrent__loading-indicator"
          />
        }

        {/* ================================ */}
        {/* NORMAL STATE - TOTALIZER         */}
        {/* ================================ */}
        {
          !uiTotalizer.isFetching &&
          <StockTotalizer data={stockCurrentTotalizer} />
        }

        {/* ================================ */}
        {/* ERROR STATE - TABLE              */}
        {/* ================================ */}
        {
          ui.error &&
          <AlertMessage
            error
            className="StockCurrent__error-message"
            message="Ocorreu um erro ao carregar os produtos."
            actionText="Tente novamente"
            onRetry={this._onRetry}
          />
        }

        {/* ================================ */}
        {/* LOADING STATE - TABLE            */}
        {/* ================================ */}
        {
          ui.isFetching &&
          <LoadingIndicator
            text="Carregando produtos"
            theme="dark"
            className="StockCurrent__loading-indicator"
          />
        }

        {/* ================================ */}
        {/* NORMAL STATE - TABLE             */}
        {/* ================================ */}
        {
          !ui.isFetching &&
          !ui.error && (
            stockCurrentList[0] ?
              <GroupedTable
                data={stockCurrentList}
                grouped={grouped}
              /> :
              <EmptyState
                className="StockCurrent__empty-state"
                message="Não existem dados para a busca realizada."
              />
          )
        }

      </div>
    );
  }
}

const mapStateToProps = state => ({
  ui: getStockCurrentUI(state),
  grouped: state.stock.grouped,
  stockCurrentList: getStockCurrentList(state),
  uiTotalizer: getStockCurrentTotalizerUI(state),
  stockCurrentTotalizer: state.stock.stockCurrentTotalizer.data,
});

StockCurrent.propTypes = propTypes;
StockCurrent.defaultProps = defaultProps;

export default connect(mapStateToProps)(StockCurrent);
